import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {collection, getDocs, getFirestore, limit, query, orderBy} from 'firebase/firestore';
import {Report} from '../model/objects';


export const loadRecentReports = createAsyncThunk(
  'dash/loadReports',
  async (arg, {getState, rejectWithValue}) => {
    const org = getState().auth.org.id;
    try {
      const result = await getDocs(query(collection(getFirestore(),'orgs', org, 'reports' ),
        orderBy('created', 'desc'),
        limit(5)
      ));
      return result.docs.map(Report.create);
    }
    catch(err) {
      return rejectWithValue(err);
    }
  }
)
const dash = createSlice({
  name: 'dash',
  initialState: {
    reports: []
  },
  reducers: {
  },
  extraReducers: builder => {
    builder
      .addCase(loadRecentReports.fulfilled, (state, action) => {
        state.reports = action.payload;
      })
  }
});

// export const {} = dash.actions;

export default dash.reducer;
